import { useEffect, useState } from "react";
import { adresPro2, findLokal, sortujLokale } from "../../../functions/ulice";
import WodaMieszkancySeryjneSelect from "./WodaMieszkancySeryjneSelect";
import WodaMieszkancySeryjneTabela from "./WodaMieszkancySeryjneTabela";
import WodaMieszkancySeryjneWydruki from "./WodaMieszkancySeryjneWydruki";


const WodaMieszkancySeryjne = props => {

    const { rozliczenieWody, ulice, lokale, mieszkancy, udzialyKontaAkt, grupy, wybranaWspolnota } = props;

    const [wybraneRozliczenie, setWybraneRozliczenie] = useState(undefined);
    const [zestaw, setZestaw] = useState(undefined);
    
    useEffect( () => {
        const temp = wybraneRozliczenie?.procenty?.filter( p => p?.czyRozliczac === true)?.map( procent => {
            const mieszkaniec = mieszkancy?.find( m => m?.id_user == procent?.id_user);
            const udzial = udzialyKontaAkt?.find( u => u?.id_user == procent?.id_user && u?.grupa_numer == procent?.grupa_numer );
            const grupy_u = grupy?.filter( g => g?.id_user == procent?.id_user && g?.grupa_numer == procent?.grupa_numer );

            const lokal = findLokal(udzial, grupy, lokale);
            const adres = adresPro2(udzial, lokale, ulice, grupy_u);
            const odczyty = wybraneRozliczenie?.odczytyWZakresie?.find( o => o?.id_user == procent?.id_user && o?.grupa_numer == procent?.grupa_numer );

            return ({    
                procent,
                mieszkaniec,
                adres,
                ulicaId: lokal?.ulica,
                lokalNr: lokal?.numer,
                odczyty,
            })
        });
        setZestaw( temp ? sortujLokale(temp) : []);
    },[wybranaWspolnota, wybraneRozliczenie, mieszkancy, udzialyKontaAkt, grupy, lokale, ulice])

    useEffect( () => setWybraneRozliczenie(undefined), [wybranaWspolnota])

    return (
        <div className="woda-content-seryjne">
            <div className="lewa">
                <WodaMieszkancySeryjneSelect
                    rozliczenieWody={rozliczenieWody}
                    setWybraneRozliczenie={setWybraneRozliczenie}
                />
                <WodaMieszkancySeryjneTabela
                    zestaw={zestaw}
                />
            </div>
            <div className="prawa">
                <WodaMieszkancySeryjneWydruki
                    wybraneRozliczenie={wybraneRozliczenie}
                    wybranaWspolnota={wybranaWspolnota}
                    zestaw={zestaw}
                />
            </div>

        </div>
    )
}

export default WodaMieszkancySeryjne;